<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div :model="dataForm" class="whiteForm">
      <van-row>
        <van-col span="6">姓</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.lastName" placeholder="请输入英文(拼音)姓">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">名</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.firstName" placeholder="请输入英文(拼音)名">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">电子邮箱</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.email" placeholder="请输入电子邮箱">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">生    日</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.birthday" placeholder="请输入生日" readonly @click="showDateSelect=true">
        </van-col>
      </van-row>
      <br>
      <p><van-button type="info" size="large" :loading="editStudentLoading" loading-text="保存中..." @click="editStudent">保存</van-button></p>
      <p><van-button v-if="dataForm.studentId" type="info" plain size="large" :loading="editStudentLoading" loading-text="删除中..." @click="deleteStudent">删除</van-button></p>
    </div>
    <van-popup v-model="showDateSelect" position="bottom">
      <van-datetime-picker
        v-model="birthday1"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="onDateConfirm"
        @cancel="onDateCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, MyNotify } from '@/utils/base'
import { Button, DatetimePicker, Popup, Dialog } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      title: '学员信息编辑',
      backurl: '/store/studentList',
      showDateSelect: false,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      birthday1: new Date(1990, 1, 1),
      editStudentLoading: false,
      orderId: undefined,
      dataForm: {
        studentId: undefined,
        lastName: undefined,
        firstName: undefined,
        email: undefined,
        birthday: undefined
      }
    }
  },
  activated() {
    this.minDate = new Date(1900, 1, 1)
  },
  created() {
    initPage()
    this.orderId = getUrlKey('orderId')
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url + '?orderId=' + this.orderId
    } else {
      this.backurl = '/store/studentList' + '?orderId=' + this.orderId
    }
    if (this.$route.params.id !== '0') {
      this.dataForm.studentId = this.$route.params.id
      request({
        url: '/Store/getStudents',
        method: 'get',
        params: { studentId: this.dataForm.studentId }
      }).then(Response => {
        if (Response.success) {
          this.dataForm.lastName = Response.data.lastName
          this.dataForm.firstName = Response.data.firstName
          this.dataForm.email = Response.data.email
          this.birthday1 = Response.data.birthday
          this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
        }
      })
    }
  },
  methods: {
    editStudent() {
      this.editStudentLoading = true
      request({
        url: '/Store/updateStudent',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.editStudentLoading = false
        if (Response.success) {
          MyNotify('success', '保存学员信息成功', 2000)
          this.$router.replace(this.backurl)
        }
      })
    },
    deleteStudent() {
      Dialog.confirm({
        title: '删除学员信息',
        message: '是否要删除这条学员信息',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.editStudentLoading = true
        request({
          url: '/Store/deleteStudent',
          method: 'post',
          params: { studentId: this.dataForm.studentId }
        }).then(Response => {
          this.editStudentLoading = false
          if (Response.success) {
            MyNotify('success', '删除学员信息成功', 2000)
            this.$router.replace(this.backurl)
          }
        })
      })
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    formatDate,
    onDateConfirm() {
      this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    onDateCancel() {
      this.showDateSelect = false
      this.dataForm.birthday = undefined
    }
  }
}
</script>
